<template>
  <section class="section cta-section">
    <div class="footer-cta-card">
      <h2 class="section-title">{{ $t('home.ctaTitle') }}</h2>
      <p>{{ $t('home.cta.subtitle') }}</p>
      <div class="action-buttons">
        <button @click="$emit('start')" class="btn btn-primary">
          <span class="material-icons" aria-hidden="true">arrow_forward</span>
          {{ $t(isLoggedIn ? 'home.startButton' : 'home.loginToStart') }}
        </button>
        <button @click="$emit('demo')" class="btn btn-secondary">
          <span class="material-icons-outlined" aria-hidden="true">headphones</span>
          {{ $t('home.tryDemo') }}
        </button>
      </div>
      <div class="footer-cta-notes">
        <span v-for="note in $tm('home.cta.notes')" :key="note">{{ note }}</span>
      </div>
    </div>

    <footer class="site-footer">
      <div class="footer-brand">
        <div class="footer-logo">
          <img src="@/assets/logo.png" alt="GoodScriber logo">
          <strong>GoodScriber</strong>
        </div>
        <p>{{ $t('home.footer.description') }}</p>
        <a class="footer-email" href="mailto:goodscriber@gmail.com">
          goodscriber@gmail.com
        </a>
        <nav class="footer-social" :aria-label="isChineseLocale ? '关注我们' : 'Follow us'">
          <a
            href="https://www.tiktok.com/@goodscriber.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            title="TikTok"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
            </svg>
          </a>
          <a
            href="https://www.rednote.com/user/profile/62db50cb000000001e01cac7?xsec_token=AB1qNpML88dAFVYzEtR1gwDyf30VeFkZwaj9IbQeCBsM0%3D&amp;xsec_source=pc_user"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="isChineseLocale ? '小红书' : 'Rednote'"
            :title="isChineseLocale ? '小红书' : 'Rednote'"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <mask id="footer-rednote-mask">
                <rect width="24" height="24" fill="#fff" />
                <text x="12" y="14.6" text-anchor="middle" textLength="18" lengthAdjust="spacingAndGlyphs" font-size="6.6" font-weight="700" fill="#000">小红书</text>
              </mask>
              <rect x="1" y="1" width="22" height="22" rx="5" mask="url(#footer-rednote-mask)" />
            </svg>
          </a>
          <a
            href="https://discord.gg/q6sAmJJFW"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="isChineseLocale ? '加入 Discord 群，获取帮助' : 'Join our Discord for help'"
            :title="isChineseLocale ? '加入 Discord 群，获取帮助' : 'Join our Discord for help'"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
            </svg>
          </a>
        </nav>
      </div>

      <nav class="footer-column footer-column-product" :aria-label="$t('home.footer.product')">
        <strong>{{ $t('home.footer.product') }}</strong>
        <a href="#features">{{ $t('home.footer.scenarios') }}</a>
        <a href="#workflow">{{ $t('home.footer.workflow') }}</a>
        <a href="#pricing">{{ $t('home.footer.pricing') }}</a>
        <button type="button" @click="$emit('demo')">{{ $t('home.footer.demoAudio') }}</button>
      </nav>

      <nav class="footer-column footer-column-resources" :aria-label="$t('home.footer.resources')">
        <strong>{{ $t('home.footer.resources') }}</strong>
        <a href="#faq">{{ $t('home.footer.faq') }}</a>
        <button type="button" @click="openFeedback()">{{ $t('home.footer.feedback') }}</button>
        <router-link :to="guideIndexPath">{{ guideIndexLabel }}</router-link>
        <router-link
          v-for="guide in footerGuideLinks"
          :key="guide.path"
          :to="guide.path"
        >
          {{ guide.label }}
        </router-link>
      </nav>

      <nav class="footer-column footer-column-legal" :aria-label="$t('home.footer.legal')">
        <strong>{{ $t('home.footer.legal') }}</strong>
        <router-link to="/privacy">{{ $t('legal.privacyLink') }}</router-link>
        <router-link to="/terms">{{ $t('legal.termsLink') }}</router-link>
        <router-link to="/refund">{{ $t('legal.refundLink') }}</router-link>
      </nav>

      <div class="footer-bottom">
        <span>{{ $t('home.footer.copyright') }}</span>
        <span>{{ $t('home.footer.tagline') }}</span>
      </div>
    </footer>
  </section>
</template>

<script>
import { openFeedback } from '@/composables/useFeedback'

export default {
  name: 'HomeFooter',
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    footerTools: {
      type: Array,
      required: true
    }
  },
  computed: {
    isChineseLocale() {
      return String(this.$i18n.locale || '').toLowerCase().startsWith('zh')
    },
    guideIndexPath() {
      return this.isChineseLocale ? '/zh/learn' : '/learn'
    },
    guideIndexLabel() {
      return this.isChineseLocale ? '英语学习指南' : 'Learning guides'
    },
    footerGuideLinks() {
      return this.isChineseLocale
        ? [
            { path: '/zh/learn/yingyu-genduxunlian-zenme-zuo', label: '英语跟读训练' },
            { path: '/zh/learn/yinpin-zhuan-wenzi-xue-yingyu', label: '音频转文字学英语' },
            { path: '/zh/learn/yasi-kouyu-yong-tts-lianxi', label: '雅思口语 TTS 练习' }
          ]
        : [
            { path: '/learn/how-to-practice-shadowing-with-audio', label: 'Shadowing with audio' },
            { path: '/learn/audio-to-text-for-language-learning', label: 'Audio to text for learning' },
            { path: '/learn/text-to-speech-for-ielts-speaking', label: 'TTS for IELTS speaking' }
          ]
    }
  },
  methods: {
    openFeedback
  },
  emits: ['start', 'demo']
};
</script>
